import { Col, Container, Row } from "react-bootstrap";
import NotificationEntryForm from "../../../Components/Forms/NotificationEntryForm/NotificationEntryForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useAddNewNotificationEntryMutation } from "../../../services/bClientApi";

export default function AddNotificationEntryPage() {

  const [
    addNewNotificationEntry,
    {
      isLoading,
      error
    }
  ] = useAddNewNotificationEntryMutation()

  const dispatch = useAppDispatch()
  const handleSubmit = async (data: any) => {
    const values: any = {
      ...data
    }
    const newNotificationEntry = await addNewNotificationEntry(values).unwrap()
    if (newNotificationEntry._id) {
      dispatch(navigateTo(`/notification-entry/${newNotificationEntry._id}`))
    }
    return newNotificationEntry
  }

  return (
    <Container>
      <Row>
        <Col>
          <h1>Add Notification Entry</h1>
          <hr />
          {error && (<>{JSON.stringify(error)}<br /></>)}

          <NotificationEntryForm
            initialValues={{
                userId: '',
            }}
            disabled={isLoading}
            onSubmit={handleSubmit}
          />

        </Col>
      </Row>
    </Container>
  )
}
